/**
 * 菜单权限工具
 * 基于 /api/consumer/getConsoleMenuPermission 返回的 menuConfigs
 * 配合路由 meta.permission1 字段判断当前路由是否有权限
 *
 * 规则：
 * 1. permission1 为空/未配置：视为不需要权限校验（默认允许通过）
 * 2. menuConfigs 不存在或非对象：异常兜底，拒绝访问（除非 permission1 为空）
 * 3. menuConfigs[permission1] === 1 视为有权限；
 *    其它任何取值（0、undefined、null、false 等）均视为无权限
 *
 * @param {string} permission1 路由 meta 中的 permission1 字段
 * @param {object} menuConfigs 接口返回的 data.menuConfigs 对象
 * @returns {boolean} 是否有权限
 */
export function hasMenuPermission(permission1, menuConfigs) {
  // 1. 路由未配置权限项，直接放行
  if (!permission1 || typeof permission1 !== 'string') {
    return true;
  }

  // 2. menuConfigs 异常兜底（null、undefined、非对象）
  if (!menuConfigs || typeof menuConfigs !== 'object') {
    return false;
  }

  // 3. 严格判定值为 1 才算有权限
  return menuConfigs[permission1];
}

/**
 * 从接口响应中安全地取出 menuConfigs
 * 兼容各种异常返回（空对象、缺字段等）
 *
 * @param {object} response 接口响应
 * @returns {object|null} menuConfigs 对象，异常时返回 null
 */
export function extractMenuConfigs(response) {
  if (!response || typeof response !== 'object') {
    return null;
  }
  const data = response.data;
  if (!data || typeof data !== 'object') {
    return null;
  }
  return data;
}

export default {
  hasMenuPermission,
  extractMenuConfigs
};



// WEBPACK FOOTER //
// ./src/utils/menuPermission.js